export default function ComparisonSection() {
  return (
    <section className="py-16 md:py-24 px-6 md:px-10 lg:px-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block text-xs font-medium text-primary-600 uppercase tracking-widest mb-3">
            Confronto
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900 mb-3">
            Itaobuy Spreadsheet vs ricerca tradizionale
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            Scopri perch&eacute; il nostro metodo &egrave; pi&ugrave; efficiente
          </p>
        </div>

        <div className="max-w-3xl mx-auto bg-background-50 rounded-2xl overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="border-b border-background-200">
                  <th className="text-left py-4 px-6 text-sm font-semibold text-foreground-700">Caratteristica</th>
                  <th className="text-center py-4 px-6 text-sm font-semibold text-primary-600">
                    <div className="flex items-center justify-center gap-2">
                      <i className="ri-file-list-3-line"></i>
                      Itaobuy Spreadsheet
                    </div>
                  </th>
                  <th className="text-center py-4 px-6 text-sm font-semibold text-foreground-400">
                    Ricerca normale
                  </th>
                </tr>
              </thead>
              <tbody>
                {[
                  { feat: 'Prodotti organizzati', ss: true, normal: false },
                  { feat: 'Filtri per categoria', ss: true, normal: 'Limitato' },
                  { feat: 'Foto QC', ss: true, normal: 'Raro' },
                  { feat: 'Risparmio di tempo', ss: 'Alto', normal: 'Basso' },
                  { feat: 'Aggiornamenti regolari', ss: true, normal: false },
                  { feat: 'Guide in italiano', ss: true, normal: false },
                ].map((row, idx) => (
                  <tr key={idx} className="border-b border-background-100 last:border-0">
                    <td className="py-3.5 px-6 text-sm text-foreground-700">{row.feat}</td>
                    <td className="py-3.5 px-6 text-center">
                      {typeof row.ss === 'boolean' ? (
                        row.ss ? (
                          <span className="inline-flex items-center text-accent-600"><i className="ri-check-line text-base mr-1"></i></span>
                        ) : (
                          <span className="inline-flex items-center text-foreground-300"><i className="ri-close-line text-base mr-1"></i></span>
                        )
                      ) : (
                        <span className="text-sm font-medium text-accent-600">{row.ss}</span>
                      )}
                    </td>
                    <td className="py-3.5 px-6 text-center">
                      {typeof row.normal === 'boolean' ? (
                        row.normal ? (
                          <span className="inline-flex items-center text-accent-600"><i className="ri-check-line text-base mr-1"></i></span>
                        ) : (
                          <span className="inline-flex items-center text-foreground-300"><i className="ri-close-line text-base mr-1"></i></span>
                        )
                      ) : (
                        <span className="text-sm text-foreground-400">{row.normal}</span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
}